<template>
  <div class="two-container">
    <div class="little-title">{{$theme ? '行业案例' : 'INDUSTRY CASE'}}</div>
    <div class="model-three">
      <div class="left-con">

      
        <div class="left-img">
          <div class="sx" v-show="activeProject == item.code" v-for="item in projectList" :key="item.code+'sx'">
            <img :src="item.img" alt="">
            <div class="img-con" :style="{backgroundImage: 'url('+item.img+')'}"></div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="right-list">
        <div
          @click="changeItem(item)"
          :class="{ 'active-project': activeProject == item.code, 'item-eng-2': !$theme }"
          class="project-list"
          v-for="(item, ind) in projectList"
          :key="ind + 'sb'"
        >
          <span class="name">{{ $theme ? item.name : item.enName }}</span>
          <div class="quan">
            <div class="con">
              <i class="el-icon-right"></i>
              <i class="el-icon-right"></i>
            </div>
            
          </div>
          <span>0{{ ind + 1 }}</span>
        </div>
      </div>
    </div>
    <img class="point-bg" :src="pointBg" alt="">
  </div>
</template>

<script>
import img1 from '/static/image/home/hyal-1.png'
import img2 from '/static/image/home/hyal-2.png'
import img3 from '/static/image/home/hyal-3.png'
import img4 from '/static/image/home/hyal-4.png'
import img5 from '/static/image/home/hyal-5.png'
import img6 from '/static/image/home/hyal-6.png'
import img7 from '/static/image/home/hyal-7.png'
import img8 from '/static/image/home/hyal-8.png'
import pointBg from '/static/image/home/point-bg.png'
export default {
  data() {
    return {
      activeProject: 1,
      pointBg,
      projectList: [
        {
          name: "智慧林草",
          enName: 'Smart Forestry and Grassland',
          code: 1,
          img: img1,
        },
        {
          name: "智慧碳汇",
          enName: 'Smart Carbon Sequestration',
          code: 2,
          img: img2,
        },
        {
          name: "智慧环保",
          enName: 'Smart Environmental Protection',
          code: 3,
          img: img3,
        },
        {
          name: "仓储物流",
          enName: 'Warehousing and Logistics',
          code: 4,
          img: img4,
        },
        {
          name: "城市治理",
          enName: 'Urban Governance',
          code: 5,
          img: img5,
        },
        {
          name: "智慧校园",
          enName: 'Smart Campus',
          code: 6,
          img: img6,
        },
        {
          name: "智慧应急",
          enName: 'Smart Emergency',
          code: 7,
          img: img7,
        },
        {
          name: "智慧公安",
          enName: 'Smart Public Security',
          code: 8,
          img: img8,
        },
      ],
      // currentImg: require("/static/image/home/hyal-1.png"),
    };
  },
  props: {},
  components: {},
  computed: {},
  methods: {
    changeItem(item){
      this.activeProject = item.code
      this.currentImg = item.img
    },
  },
  created() {
    // this.currentImg = this.projectList[0].img
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
